<template>
<div id="options-modal" class="modal fade">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Options</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <input type="checkbox" v-model="options.enable_debug">Enable Console Debug</input>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {options} from '@/js/io.js'

export default {
  name: 'OptionsModal',
  
  data() { return { options: options } }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UI/OptionsModal.vue